import { ErrorReportingClient } from '../types/ErrorReportingClient';
import { ErrorReportingDevtools } from '../types/ErrorReportingDevtools';

/**
 * Forces the error-reporting client to flush any pending events.
 * Resolves with `true` when the queue drained inside `timeout` ms.
 */
export const createFlushDevtool = (
  client: ErrorReportingClient,
): ErrorReportingDevtools['flush'] => {
  return (timeout): Promise<boolean> => client.flush(timeout);
};
